function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M100.8,185.3c-2.5,0-4.9-0.7-7-1.9l-64.1-37.7c-4.2-2.5-6.8-7.1-6.8-12l0.6-74.4 c0-4.9,2.7-9.5,7-11.9l64.7-36.6c2.1-1.2,4.4-1.8,6.8-1.8c2.5,0,4.9,0.7,7,1.9l64.1,37.7c4.2,2.5,6.8,7.1,6.8,12l-0.6,74.4 c0,4.9-2.7,9.5-7,11.9l-64.7,36.6C105.5,184.7,103.2,185.3,100.8,185.3z M101,170.4l64-36.2l0.6-73.5l-63.3-37.3l-64,36.2l-0.6,73.5 L101,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "#3B086B"
    },
    d: "M98.3,182.4c-1.8,0-3.7-0.5-5.3-1.4l-62-36.5c-3.2-1.9-5.2-5.4-5.2-9.1l0.6-72 c0-3.7,2.1-7.2,5.3-9.1l62.6-35.4c3.3-1.8,7.3-1.8,10.5,0.1l62,36.5c3.2,1.9,5.2,5.4,5.2,9.1l-0.6,72c0,3.7-2.1,7.2-5.3,9.1 l-62.6,35.4C101.9,182,100.1,182.4,98.3,182.4z M99.5,26.5c-0.2,0-0.5,0.1-0.7,0.2L36.2,62.2c-0.5,0.3-0.8,0.8-0.8,1.3l-0.6,72 c0,0.5,0.3,1,0.7,1.3l62,36.5c0.5,0.3,1,0.3,1.5,0l62.6-35.4c0.5-0.3,0.8-0.8,0.8-1.3l0.6-72c0-0.5-0.3-1-0.7-1.3l-62-36.5 C100.1,26.6,99.8,26.5,99.5,26.5L99.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M132.7,142.9c-4,0-7.3-3.3-7.3-7.3v-42c0-4,3.3-7.3,7.3-7.3s7.3,3.3,7.3,7.3v42 C140.1,139.6,136.8,142.9,132.7,142.9z M102.8,142.9c-4,0-7.3-3.3-7.3-7.3v-28c0-4,3.3-7.3,7.3-7.3s7.3,3.3,7.3,7.3v28 C110.1,139.6,106.8,142.9,102.8,142.9z M72.2,142.9c-4,0-7.3-3.3-7.3-7.3v-24.3c0-4,3.3-7.3,7.3-7.3s7.3,3.3,7.3,7.3v24.3 C79.5,139.6,76.2,142.9,72.2,142.9z M136.9,84.6c-4,0-7.3-3.3-7.3-7.3V63.1h-14.1c-4,0-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3h21.5 c4,0,7.3,3.3,7.3,7.3v21.5C144.2,81.3,140.9,84.6,136.9,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "#3B086B"
    },
    d: "M122.9,138.6c-2.5,0-4.5-2-4.5-4.5v-42c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5v42 C127.4,136.5,125.3,138.6,122.9,138.6z M92.9,138.6c-2.5,0-4.5-2-4.5-4.5v-28c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5v28 C97.4,136.5,95.4,138.6,92.9,138.6z M62.3,138.6c-2.5,0-4.5-2-4.5-4.5v-24.3c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5v24.3 C66.8,136.5,64.8,138.6,62.3,138.6z M127,80.2c-2.5,0-4.5-2-4.5-4.5v-17h-17c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5H127 c2.5,0,4.5,2,4.5,4.5v21.5C131.5,78.2,129.5,80.2,127,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M69.9,100c-1.3,0-2.5,0-3.6-0.1l-0.1,0c-4-0.4-7-4-6.6-8c0.3-3.8,3.5-6.7,7.3-6.7c0.2,0,0.4,0,0.7,0 c0.1,0,1,0.1,2.5,0.1c8.1,0,36.2-2.2,57.3-31.1c1.4-1.9,3.6-3,5.9-3c1.5,0,3,0.5,4.2,1.3l0.1,0.1c1.6,1.2,2.6,2.9,2.9,4.8 c0.3,1.9-0.1,3.8-1.2,5.3l-0.1,0.2C113.9,97.3,79.7,100,69.9,100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "#3B086B"
    },
    d: "M63.7,92.8c-1.9,0-3.1-0.1-3.4-0.1c-2.5-0.2-4.3-2.4-4.1-4.9c0.2-2.5,2.4-4.3,4.9-4.1 c1.5,0.1,36.7,2.8,62.3-32.2c1.5-2,4.3-2.4,6.3-1c0,0,0,0,0,0c2,1.5,2.4,4.3,1,6.3c0,0,0,0,0,0C106.4,90,74.2,92.8,63.7,92.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.0fe560d543faf9e4d2aa4729b0784877.svg";
export { ForwardRef as ReactComponent };